import { Component, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { ClientService } from '../../services';

@Component({
    selector: 'app-spare-client-window',
    templateUrl: './spareClient.component.html'
})
export class SpareClientComponent {
    @Output() clientUpdateEvent = new EventEmitter();
    clientdata: any;
    isLoading: boolean = false;

    constructor(private clientService: ClientService, public bsModalRef: BsModalRef, public toasterService: ToasterService) {
        this.clientdata = {
            client_name: '',
            address: '',
            mobile: ''
        };
    }

    onSaveClient(): void {
        let that = this,
            data = {
                mode: "Add",
                from_page: "spareClient",
                client_name: this.clientdata.client_name,
                address: this.clientdata.address,
                mobile: this.clientdata.mobile,
                client_no: null
            };
        this.isLoading = true;
        this.clientService
            .addUpdateClient(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    data.client_no = res.client_no;
                    that.clientUpdateEvent.emit(data);
                } else {

                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };

                    that.toasterService.pop(toast);
                }

            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/common/spareClient.component.ts